// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"cfdd5466","787":"3d1e6ff1"}[chunkId] + ".chunk.js";
};